import z from "zod";
import { LayoutItemScheme } from "./layoutItem";

export const PaymentMethodButtonLayoutScheme = z.object({
  columns: z.number().int().min(1).max(6).optional(),
  rowsBeforeShowAll: z.number().int().min(1).max(8).optional(),
  buttons: z.array(LayoutItemScheme).optional(),
});

export type PaymentMethodButtonLayout = z.infer<
  typeof PaymentMethodButtonLayoutScheme
>;
